import React from "react"
import { Box, List } from "@mui/material"
import Icon from "@mdi/react"
import { mdiTune } from "@mdi/js"

import Button from "components/Buttons/Button"
import Filter from "components/Algolia/Filters/Filter"

import useToggle from "@secureo/common/hooks/useToggle"

import { FilterConfig } from "@secureo/common/typings/Algolia"
import { SearchState } from "react-instantsearch-core"

const FilterMobile = ({ totalNumberOfResults, filters }: Props) => {
	const [isOpen, toggleIsOpen] = useToggle()

	return (
		<>
			<Button color="link-no-underline" onClick={toggleIsOpen}>
				<Icon path={mdiTune} size={1} color="black" />
				<Box style={{ marginLeft: 4 }}>
					<strong>Filtern</strong>
				</Box>
			</Button>
			<div
				style={{
					height: "100%",
					width: "100%",
					position: "fixed",
					zIndex: 9998,
					top: 0,
					left: isOpen ? "0%" : "-100%",
					background: "white",
				}}
			>
				<Box
					py={1}
					style={{
						background: "#E7EFF6",
						color: "#263739",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Icon path={mdiTune} size={1} color="#263739" />
					<Box ml={1}>
						<strong>Filtern</strong>
					</Box>
				</Box>
				<List style={{ paddingBottom: 150 }}>
					{filters.map((filterConfig) => {
						const { attribute } = filterConfig

						return <Filter key={attribute} filterConfig={filterConfig} />
					})}
				</List>
				<div
					style={{
						left: "50%",
						transform: "translateX(-50%)",
						position: "absolute",
						bottom: 50,
						width: 200,
					}}
				>
					<Button color="secondary" onClick={toggleIsOpen}>
						{totalNumberOfResults} anzeigen
					</Button>
				</div>
			</div>
		</>
	)
}

interface Props {
	totalNumberOfResults: number
	filters: FilterConfig[]
	virtualRefinements: SearchState
}

export default FilterMobile
